import { render, staticRenderFns } from "./MessageEduc.vue?vue&type=template&id=1eb8ea30&scoped=true"
import script from "./MessageEduc.vue?vue&type=script&lang=js"
export * from "./MessageEduc.vue?vue&type=script&lang=js"
import style0 from "./MessageEduc.vue?vue&type=style&index=0&id=1eb8ea30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb8ea30",
  null
  
)

export default component.exports